import React from "react";
import { useLocation } from "react-router-dom";

const useQueryParams = () => {
  // Vendors sometimes send unescaped "#" in query values (e.g. unresolved
  // macros like "[#transaction_id#]"). The browser treats that as the start
  // of the fragment, so anything after it lands in `hash`, not `search`.
  // This app never uses hash-based routing, so it's safe to stitch them
  // back together and parse the full, un-truncated query string.
  const { search, hash } = useLocation();
  return React.useMemo(
    () => new URLSearchParams(search + hash),
    [search, hash],
  );
};

export default useQueryParams;
